import * as React from "react";
const SvgBookmarkFill20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M18 2H2v16.943l8-5.714 8 5.714V2Z",
      clipRule: "evenodd"
    })
  );
export default SvgBookmarkFill20Px;
